import { render, staticRenderFns } from "./device-install1.vue?vue&type=template&id=2339786e&scoped=true&"
import script from "./device-install1.js?vue&type=script&lang=js&"
export * from "./device-install1.js?vue&type=script&lang=js&"
import style0 from "./device-install1.css?vue&type=style&index=0&id=2339786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339786e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
